import gql from 'graphql-tag';
import { ECHELON_INFO_FRAGMENT } from '../echelon/fragment';
import { ENSEIGNE_INFO_FRAGMENT } from '../enseigne/fragment';
import { ENTITY_FRAGMENT } from './fragment';

export const UPSERT_ENTITY = gql`
  mutation UpsertEntity($input: UpsertEntityInput!) {
    upsertEntity(input: $input) {
      ...EntityInfo
      managers {
        id
      }
      echelon {
        ...EchelonInfo
      }
      enseigne {
        ...EnseigneInfo
      }
      parentEntity {
        ...EntityInfo
      }
      reseau {
        ...EntityInfo
      }
    }
  }
  ${ENTITY_FRAGMENT}
  ${ECHELON_INFO_FRAGMENT}
  ${ENSEIGNE_INFO_FRAGMENT}
`;

export const CREATE_ENTITY = gql`
  mutation CreateEntity($input: CreateEntityInput!) {
    createEntity(input: $input) {
      ...EntityInfo
      managers {
        id
      }
      echelon {
        ...EchelonInfo
      }
      enseigne {
        ...EnseigneInfo
      }
      parentEntity {
        ...EntityInfo
      }
      reseau {
        ...EntityInfo
      }
    }
  }
  ${ENTITY_FRAGMENT}
  ${ECHELON_INFO_FRAGMENT}
  ${ENSEIGNE_INFO_FRAGMENT}
`;

export const UPDATE_ENTITY = gql`
  mutation UpdateEntity($input: UpdateEntityInput!) {
    updateEntity(input: $input) {
      ...EntityInfo
      managers {
        id
      }
      echelon {
        ...EchelonInfo
      }
      enseigne {
        ...EnseigneInfo
      }
      parentEntity {
        ...EntityInfo
      }
      reseau {
        ...EntityInfo
      }
    }
  }
  ${ENTITY_FRAGMENT}
  ${ECHELON_INFO_FRAGMENT}
  ${ENSEIGNE_INFO_FRAGMENT}
`;

export const DELETE_ENTITY = gql`
  mutation DeleteEntity($entityIds: [Int!]!) {
    deleteEntity(entityIds: $entityIds) {
      ...EntityInfo
    }
  }
  ${ENTITY_FRAGMENT}
`;

export const ADD_USER_IN_ENTITY = gql`
  mutation addUsersInEntity($input: AddUsersInEntityInput!) {
    addUsersInEntity(input: $input) {
      ...EntityInfo
    }
  }
  ${ENTITY_FRAGMENT}
`;

export const IMPORT_ENTITIES = gql`
  mutation ImportEntities($inputs: [ImportEntitiesInput]) {
    importEntities(inputs: $inputs)
  }
`;
